class ProductScentNotes extends HTMLElement {
  constructor() {
    super();
    this.activeItem = this.activeItem.bind(this);
    this.toggleAutoplay = this.toggleAutoplay.bind(this);
  }

  setVariables() {
    this.sliderElement = this.querySelector('[data-slider]');
    this.slides = this.sliderElement.querySelectorAll('[data-item]');
    this.noteMedia = this.querySelector('[data-note-media]');
    this.animationDuration = parseInt(this.getAttribute('animation-duration') || '2000')
  }

  connectedCallback() {
    this.setVariables()
    document.addEventListener('DOMContentLoaded', () => this.initSlider());
    window.addEventListener('resize', () => this.initSlider());

    this.querySelectorAll('[data-item]').forEach(toggle => {
      toggle.addEventListener('mouseover', this.activeItem)
      toggle.addEventListener('click', this.activeItem)
      toggle.addEventListener('focus', this.activeItem)
    })

    this.querySelectorAll('[data-autoplay-toggle]').forEach(toggle => {
      toggle.addEventListener('click', this.toggleAutoplay)
    })
  }

  disconnectedCallback() {
    this.destroySlider();
    this.querySelectorAll('[data-item]').forEach(toggle => {
      toggle.removeEventListener('mouseover', this.activeItem)
      toggle.removeEventListener('click', this.activeItem)
      toggle.removeEventListener('focus', this.activeItem)
    })

    this.querySelectorAll('[data-autoplay-toggle]').forEach(toggle => {
      toggle.removeEventListener('click', this.toggleAutoplay)
    })
  }

  toggleAutoplay() {
    if (!this.flickity) return;
    if (this.classList.contains('auto-playing')) {
      this.flickity.pausePlayer()
      this.classList.remove('auto-playing')
    } else {
      this.flickity.unpausePlayer()
      this.classList.add('auto-playing')
    }
  }

  getIndex(item) {
    return Array.from(this.querySelectorAll('[data-item]')).indexOf(item)
  }

  activeItem(event) {
    if (!this.flickity) return;
    const index = this.getIndex(event.currentTarget)
    this.flickity.selectCell(index)
  }

  triggerItem (item) {
    this.querySelectorAll('[data-item]').forEach(element => {
      if (element == item) {
        element.classList.add('active')
      } else {
        element.classList.remove('active')
      }
    })
    if (this.noteMedia)
      this.noteMedia.innerHTML = item?.querySelector('[data-item-media]')?.innerHTML
  }

  initSlider() {
    this.destroySlider();
    if (this.slides.length < 2 || !this.sliderElement) return;

    this.flickity = new Flickity(this.sliderElement, {
      accessibility: true,
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'left',
      wrapAround: false,
      autoPlay: this.animationDuration,
      contain: true
    });

    this.triggerItem(this.flickity.selectedElement)

    this.flickity.on('change', (index) => {
      this.validateCarousel(index)
    })
  }

  validateCarousel() {
    if (!this.flickity) return;
    this.triggerItem(this.flickity.selectedElement)
  }

  destroySlider() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
    }

    if (this.sliderElement) this.sliderElement.classList.remove('flickity-enabled', 'flickity-rtl');
  }
}

customElements.define('product-scent-notes', ProductScentNotes);
